import { render, staticRenderFns } from "./DatasetsStatistics.vue?vue&type=template&id=d3a63c8a&scoped=true&"
import script from "./DatasetsStatistics.vue?vue&type=script&lang=js&"
export * from "./DatasetsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DatasetsStatistics.vue?vue&type=style&index=0&id=d3a63c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a63c8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
